import { useState } from "react"
import { Badge, Divider, IconButton, Menu, MenuItem, Tooltip } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { Repeat } from "lib/@components/repeat"
import { If } from "lib/@components/switch"
import { REGIME_STATES } from "./regime-states"
import { RegimeStateFilterOption } from "./regime-state-filter-option"

export function RegimeStateFilter({ selectedStates = [], onChange }) {
    const [anchor, setAnchor] = useState(null)
    const active = selectedStates.length > 0

    return (
        <>
            <Tooltip title={filterTooltip()}>
                <Badge
                    badgeContent={selectedStates.length}
                    color="primary"
                    overlap="circular"
                    onClick={open}
                    sx={{ cursor: "pointer" }}
                >
                    <IconButton
                        size="small"
                        onClick={open}
                        color={active ? "primary" : "default"}
                        aria-label="Filter by state"
                        data-cy="regime-state-filter"
                    >
                        <Iconify icon={active ? "mdi:filter" : "mdi:filter-outline"} />
                    </IconButton>
                </Badge>
            </Tooltip>
            <Menu anchorEl={anchor} open={!!anchor} onClose={close}>
                <Repeat
                    list={REGIME_STATES}
                    keyFn="id"
                    item={<RegimeStateFilterOption selectedStates={selectedStates} onToggleState={toggleState} />}
                />
                <If value={active}>
                    <Divider />
                    <MenuItem data-cy="regime-state-filter-clear" onClick={clearFilters}>
                        Clear filters
                    </MenuItem>
                </If>
            </Menu>
        </>
    )

    function open(e) {
        e.stopPropagation()
        setAnchor(e.currentTarget)
    }

    function close() {
        setAnchor(null)
    }

    function toggleState(id) {
        onChange(selectedStates.includes(id) ? selectedStates.filter((s) => s !== id) : [...selectedStates, id])
    }

    function clearFilters() {
        onChange([])
    }

    function filterTooltip() {
        if (!active) return "Filter By State"
        return `${selectedStates.length} ${"Filter".pluralize(selectedStates.length)} Applied`
    }
}
